import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, IconButton, Menu, MenuItem, Modal, Stack, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import * as ProjectHelper from '../../api/project/projectHelper';
import { title } from '../../info/Info';
import InputText from '../../shared/component/InputText';
import Span from '../../shared/component/Span';
import { IProject } from '../../shared/iProject';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import { selectProject, setProject } from '../../store/project/projectSlice';
import { selectUser } from '../../store/user/userSlice';

interface ISaveProps {}

enum ESaveType {
    Cloud,
    Local,
}

const saveFile = (filename: string, fileContent: string) => {
    let bb = new Blob([fileContent], { type: 'text/plain' });
    let a = document.createElement('a');
    a.download = filename + '.mqy';
    a.href = window.URL.createObjectURL(bb);
    a.click();
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 430,
    height: 270,
};

var projectName: string;
var saveType: ESaveType;

const Save = (props: ISaveProps) => {
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openModal, setOpenModal] = React.useState(false);

    const open = Boolean(anchorEl);

    const project = useAppSelector(selectProject);
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenModal = (type: ESaveType) => {
        saveType = type;
        setOpenModal(true);
    };

    const handleSave = async (event: any) => {
        event.preventDefault();
        let payload: IProject = cloneDeep(project.data!);
        if (projectName) payload.project!.title = projectName;
        projectName = '';
        if (saveType == ESaveType.Cloud) {
            let res = await ProjectHelper.saveProjectAsync(payload, user.data?.email!);
            if (res?.status == 200) {
                dispatch(setProject(res.data));
                setOpenModal(false);
            }
        } else {
            saveFile(payload.project!.title!, JSON.stringify(payload));
            setOpenModal(false);
        }
    };

    return (
        <Stack>
            <Button
                variant='greenLight'
                startIcon={<SaveIcon />}
                id='save-button'
                endIcon={<KeyboardArrowDownIcon />}
                aria-controls={open ? 'save-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <Span text={t('save')} />
            </Button>
            <Menu
                id='save-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'save-button',
                }}>
                <MenuItem onClick={() => handleOpenModal(ESaveType.Cloud)}>{t('saveCloud')}</MenuItem>
                <MenuItem onClick={() => handleOpenModal(ESaveType.Local)}>{t('saveLocal')}</MenuItem>
            </Menu>
            <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby='modal-save-project' aria-describedby='modal-save-project-description'>
                <Box sx={style}>
                    <form onSubmit={handleSave}>
                        <Stack variant='modal-small' height='100%' direction='column' spacing={4}>
                            <Stack variant='bottomLine' direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                <Typography variant='h5' gutterBottom>
                                    {t('saveCloud')}
                                </Typography>
                                <IconButton aria-label='close-modal' onClick={() => setOpenModal(false)}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>
                            <InputText
                                required
                                defaultValue={project.data?.project?.title!}
                                id={title}
                                inputLabel={t(title)}
                                name={title}
                                customOnChange={(e: any) => (projectName = e.target.value)}
                            />
                            <Stack direction={'row'} spacing={5} justifyContent={'flex-end'}>
                                <Button variant='white' onClick={() => setOpenModal(false)}>
                                    {t('close')}
                                </Button>
                                <Button variant='orange' type='submit'>
                                    {t('save')}
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </Box>
            </Modal>
        </Stack>
    );
};

export default Save;
